import { CompetencyMapQuestionsQuery } from "@generated/graphql";
import { CompetencyMapQuestion } from "./types";

export const extractQuestions = (competencyMap: CompetencyMapQuestionsQuery["competencyMap"]) => {
  const questions: CompetencyMapQuestion[] = [];

  competencyMap?.competences?.forEach((competence) => {
    competence.knowledgeBlockCompetences?.forEach(({ knowledgeBlock }) => {
      knowledgeBlock.skills?.forEach((skill) => {
        skill.questions?.forEach((question) => {
          questions.push({
            ...question,
            competencyTitle: competence.title,
            knowledgeBlockTitle: knowledgeBlock.title,
            skillTitle: skill.title,
          });
        });
      });
    });
  });

  return questions;
};

export const normalizeSelectedQuestionIds = (questionIds: string[], questions: CompetencyMapQuestion[]) => {
  const availableQuestionIds = new Set(questions.map((question) => question.id));

  return questionIds.filter((questionId) => availableQuestionIds.has(questionId));
};

export const getQuestionSelectionStats = (questionIds: string[], questions: CompetencyMapQuestion[]) => {
  const selectedQuestions = questions.filter((question) => questionIds.includes(question.id));
  const confirmedQuestions = selectedQuestions.filter((question) => question.confirmation);
  const unconfirmedQuestions = selectedQuestions.filter((question) => !question.confirmation);

  return {
    selectedQuestions,
    confirmedQuestions,
    unconfirmedQuestions,
    total: selectedQuestions.length,
    confirmedCount: confirmedQuestions.length,
    unconfirmedCount: unconfirmedQuestions.length,
  };
};
